export default __webpack_public_path__ + "static/media/weather-app.9e7dc8c4.png";